// Quality Assurance page Indonesian translations

export default {
  pageTitle: "Jaminan Kualitas",
  breadcrumbHome: "Beranda",
  breadcrumbServices: "Layanan",
  breadcrumbCurrent: "Jaminan Kualitas",
  
  // Service links
  customManufacturing: "Manufaktur Kustom",
  technicalSupport: "Dukungan Teknis",
  afterSalesService: "Layanan Purnajual",
  qualityAssurance: "Jaminan Kualitas",
  researchDevelopment: "Penelitian & Pengembangan",
  globalSupplyChain: "Rantai Pasokan Global",
  
  // Main content
  title: "Sistem Jaminan Kualitas yang Ketat",
  description1: "Di PT Eagle Industry Indonesia, kualitas adalah fondasi dari semua yang kami lakukan. Sistem jaminan kualitas komprehensif kami memastikan bahwa setiap produk yang meninggalkan fasilitas kami memenuhi standar internasional tertinggi dan spesifikasi pelanggan. Kami berkomitmen untuk memberikan keunggulan melalui proses kontrol kualitas sistematis dan inisiatif peningkatan berkelanjutan.",
  description2: "Sistem manajemen kualitas kami disertifikasi di bawah standar ISO 9001, menunjukkan komitmen kami terhadap kualitas yang konsisten dan kepuasan pelanggan. Kerangka kerja ini memandu proses kami dari pemilihan bahan baku hingga pengiriman produk akhir, memastikan keandalan dan kinerja dalam setiap komponen yang kami produksi.",
  
  // Framework section
  frameworkTitle: "Kerangka Jaminan Kualitas Kami:",
  framework: [
    "Sistem manajemen kualitas bersertifikat ISO 9001:2015",
    "Inspeksi dan verifikasi material masuk yang komprehensif",
    "Kontrol kualitas dalam proses pada tahap manufaktur kritis",
    "Kemampuan metrologi dan pengukuran presisi canggih",
    "Kontrol proses statistik untuk konsistensi manufaktur",
    "Pengujian produk akhir dan validasi kinerja",
    "Sistem pelacakan untuk pelacakan siklus hidup produk lengkap"
  ],
  
  // Testing capabilities section
  testingTitle: "Kemampuan Pengujian dan Inspeksi:",
  testingDescription: "Jaminan kualitas kami didukung oleh fasilitas pengujian mutakhir dan profesional kualitas yang sangat terlatih. Kami menggunakan teknik inspeksi canggih termasuk mesin pengukur koordinat, pengujian non-destruktif, analisis material, dan pengujian kinerja di bawah kondisi operasi simulasi. Kemampuan ini memastikan bahwa produk kami berkinerja andal dalam aplikasi dunia nyata.",
  
  // Metrics
  qualityStandards: "Standar Kualitas",
  qualityStandardsDesc: "Kepatuhan dengan standar dan sertifikasi internasional",
  inspectionTechnology: "Teknologi Inspeksi",
  inspectionTechnologyDesc: "Peralatan metrologi canggih untuk pengukuran presisi",
  processControl: "Kontrol Proses",
  processControlDesc: "Metode statistik memastikan konsistensi manufaktur",
  continuousImprovement: "Peningkatan Berkelanjutan",
  continuousImprovementDesc: "Tinjauan sistem dan inisiatif peningkatan reguler",
  
  // Certifications section
  certificationsTitle: "Sertifikasi Kualitas:",
  certificationsDescription: "Selain sertifikasi ISO 9001 kami, kami mempertahankan berbagai sertifikasi kualitas spesifik industri yang menunjukkan komitmen kami terhadap keunggulan. Ini termasuk ISO 14001 untuk manajemen lingkungan dan ISO 45001 untuk kesehatan dan keselamatan kerja, mencerminkan pendekatan holistik kami terhadap kualitas yang mencakup kinerja produk, tanggung jawab lingkungan, dan keselamatan tempat kerja.",
  
  // Customer QA section
  customerQATitle: "Jaminan Kualitas Pelanggan:",
  customerQADescription: "Kami bekerja sama dengan pelanggan kami untuk memahami persyaratan kualitas spesifik mereka dan mengembangkan protokol jaminan kualitas yang disesuaikan. Tim jaminan kualitas pelanggan kami menyediakan dokumentasi kualitas rinci, sertifikat kesesuaian, dan catatan pelacakan untuk memastikan transparansi lengkap dan keyakinan dalam produk kami.",
  
  // Supplier QA section
  supplierQATitle: "Manajemen Kualitas Pemasok:",
  supplierQADescription: "Jaminan kualitas kami meluas ke rantai pasokan kami melalui program kualifikasi dan pemantauan pemasok yang ketat. Kami hanya bekerja dengan pemasok yang memenuhi standar kualitas ketat kami dan melakukan audit reguler untuk memastikan kualitas konsisten dalam semua material dan komponen yang bersumber dari mitra eksternal.",
  
  // CTA button
  learnMore: "Pelajari Tentang Standar Kualitas Kami",
  
  // Related services section
  relatedServicesTitle: "Layanan Terkait",
  relatedServicesDescription: "Jelajahi layanan komprehensif lainnya",
  customManufacturingDesc: "Solusi manufaktur yang disesuaikan untuk memenuhi persyaratan pelanggan spesifik.",
  afterSalesServiceDesc: "Dukungan purnajual komprehensif untuk memastikan kepuasan pelanggan.",
  researchDevelopmentDesc: "Inovasi berkelanjutan untuk mengembangkan solusi pengecatan lanjutan.",
  readMore: "Baca selengkapnya"
};